import { handleStripeConnectToken } from './actions';

export const isIosBridge = () => {
  const isIos = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
  const notSafari = !(/(Safari)/g.test(navigator.userAgent));
  return isIos && notSafari;
};

export const handleStripeConnect = async (store, action, callback) => {
  if (await handleStripeConnectToken()) {
    callback();
  }
};
